import { z } from 'zod';

// The knowledge base (/api/knowledge). Which collections a role may read is checked by the service.

/** POST /api/knowledge/search; k defaults to 8, at most 25. */
export const KnowledgeSearchRequest = z.strictObject({
  query: z.string({ error: 'query is required' }).min(1, 'query is required'),
  collections: z.array(z.string()).nullish(),
  k: z.union([z.number().int().min(0), z.string().regex(/^\d+$/, 'must be a whole number'), z.null()]).optional(),
  rerank: z.boolean().optional(),
});
export type KnowledgeSearchRequest = z.input<typeof KnowledgeSearchRequest>;

/** POST /api/knowledge/ask */
export const KnowledgeAskRequest = z.strictObject({
  question: z.string({ error: 'question is required' }).min(1, 'question is required'),
});
export type KnowledgeAskRequest = z.input<typeof KnowledgeAskRequest>;
